export const API_URL = import.meta.env.VITE_SSO_API_URL ?? "";
export const NODE_ENV = process.env.NODE_ENV;
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? "";
